import React from 'react';
import './App.css';
import { Intro } from './components/intro';
import {About} from "./components/about";
import {Projects} from "./components/projects";
import {Contact} from "./components/contact";

// Sailing (the 3D ocean scene) pulls in three.js, by far the heaviest
// dependency in this app — bundling it eagerly delayed the very first
// paint of everything above it, even though the scene itself only shows up
// after scrolling past Projects. Loading it via a separate chunk means the
// initial bundle the browser has to fetch/parse before anything renders no
// longer includes it; the chunk is fetched in the background afterward
// (see componentDidMount below) so it's normally already there by the time
// a visitor scrolls down to it.
const Sailing = React.lazy(() =>
    import('./components/sailing').then((module) => ({ default: module.Sailing }))
);

interface State {
    refs: {}
}

interface Props {}

export class App extends React.Component<Props, State>{
    //const accentColor: boolean = true;

    componentDidMount(): void {
        // Kick off the Sailing chunk's download right after the initial
        // (fast) paint, rather than waiting for the user to actually
        // scroll it into view — keeps the "first load" fast without
        // trading it for a visible loading gap once they get there.
        import('./components/sailing');
    }

    render(): React.ReactNode {
        return (
            <div className="App">
                <Intro/>
                <About/>
                <Projects/>
                <React.Suspense
                    fallback={
                        // Matches Sailing's own background gradient (see
                        // sailing/style.scss) so there's no flash/jump —
                        // inlined rather than relying on that stylesheet,
                        // which is part of the same chunk still loading.
                        <div
                            style={{
                                width: "100%",
                                height: "100vh",
                                background: "linear-gradient(180deg, #bfe3e0 0%, #1e2e40 140%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <span
                                style={{
                                    color: "white",
                                    fontWeight: "bolder",
                                    fontSize: "2.5rem",
                                    textAlign: "center",
                                }}
                            >
                                Let's go sailing!
                            </span>
                        </div>
                    }
                >
                    <Sailing/>
                </React.Suspense>
                <Contact/>
            </div>
        );
    }
}

export default App;

